import React, { useState, useEffect } from 'react';
import SupplyChainContract from '../../contracts/SupplyChainContract'; 
import tickImage from '../../img/tick.png'
import crossImage from '../../img/cross.png';


const InspectorPage = () => {
  const [batchIdForUpdateInspectorVC, setBatchIdForUpdateInspectorVC] = useState('');
  const [inspectorCheck, setInspectorCheck] = useState(false);
  const [remarkEnabledInspectorVC, setRemarkEnabledInspectorVC] = useState(false); 
  const [remarkInspectorVC, setRemarkInspectorVC] = useState('');
  const [dangerCheck, setDangerCheck] = useState(false);

  const [batchIdForUpdateHealthStatus, setBatchIdForUpdateHealthStatus] = useState('');
  const [dangerCheckHealth, setDangerCheckHealth] = useState(false);
  const [approval, setApproval] = useState(false);
  const [remarkEnabledHealthStatus, setRemarkEnabledHealthStatus] = useState(false); 
  const [remarkHealthStatus, setRemarkHealthStatus] = useState('');


  const [batchIdForSearch, setBatchIdForSearch] = useState('');
  const [searchedInspectorVC, setSearchedInspectorVC] = useState(null);

  const [inspectorVCs, setInspectorVCs] = useState([]);
  const [searchInputInspector, setSearchInputInspector] = useState('');

  const [farmerVCDetails, setFarmerVCDetails] = useState([]);
  const [farmData, setFarmData] = useState(null);


  
  const handleUpdateInspectorVC = async () => {
    try {
      const batchId = parseInt(batchIdForUpdateInspectorVC);

      if (isNaN(batchId)) {
        console.error('Invalid BatchID. Please enter a valid number.');
        return;
      }

      await SupplyChainContract.methods
        .updateInspectorVC(batchId, inspectorCheck, remarkInspectorVC, dangerCheck) 
        .send({ from: window.ethereum.selectedAddress });

      const updatedFarmData = await SupplyChainContract.methods.getFarmerVCByBatchId(batchId).call();

      setFarmData(updatedFarmData);

      alert('InspectorVC updated successfully!');
    } catch (error) {
      console.error('Error updating InspectorVC:', error);
    }
  };

  
  const handleUpdateHealthStatus = async () => {
    try {
      const batchId = parseInt(batchIdForUpdateHealthStatus);
  
      if (isNaN(batchId)) {
        console.error('Invalid BatchID. Please enter a valid number.');
        return;
      }
  
      await SupplyChainContract.methods
        .reportHealthIssues(batchId, remarkHealthStatus, dangerCheckHealth, approval) 
        .send({ from: window.ethereum.selectedAddress });

      alert('Health status updated successfully!');
    } catch (error) {
      console.error('Error updating health status:', error);
    }
  };
  

  const handleSearchByBatchIdInspector = async () => {
    try {
      const batchId = parseInt(batchIdForSearch);

      if (isNaN(batchId)) {
        console.error('Invalid BatchID. Please enter a valid number.');
        return;
      }

      const inspectorVC = await SupplyChainContract.methods.getInspectorVCByBatchId(batchId).call();

      if (inspectorVC.batchID !== 0) {
        setSearchedInspectorVC(inspectorVC);
      } else {
        setSearchedInspectorVC(null);
        console.log('No InspectorVC found with the specified BatchID.');
      }
    } catch (error) {
      console.error('Error fetching InspectorVCs:', error);
    }
  };

  const handleFetchAllInspectorVCs = async () => {
    try {
      const totalInspectorVCs = await SupplyChainContract.methods.getTotalInspectorVCs().call();

      const inspectorVCList = [];
      const farmerVCDetailsList = [];

      for (let i = 1; i <= totalInspectorVCs; i++) {
        const inspectorVC = await SupplyChainContract.methods.getInspectorVCByBatchId(i).call();
        inspectorVCList.push(inspectorVC);

        const farmerVC = await SupplyChainContract.methods.getFarmerVCByBatchId(inspectorVC.batchID).call();
        farmerVCDetailsList.push(farmerVC);
      }

      setInspectorVCs(inspectorVCList);
      setFarmerVCDetails(farmerVCDetailsList);
    } catch (error) {
      console.error('Error fetching all InspectorVCs:', error);
    }
  };

  const convertEpochToDateTime = (epoch) => {
    const date = new Date(epoch * 1000);
    return date.toLocaleString();
  };

  useEffect(() => {
    handleFetchAllInspectorVCs();
  }, []); 

  useEffect(() => {
    const fetchFarmData = async () => {
      try {
        const batchId = parseInt(batchIdForUpdateInspectorVC);

        if (isNaN(batchId)) {

          setFarmData(null); 
          return;
        }

        const farmerVC = await SupplyChainContract.methods.getFarmerVCByBatchId(batchId).call();

        setFarmData(farmerVC);
      } catch (error) {
        console.error('Error fetching farm data:', error);
      }
    };

    fetchFarmData();
  }, [batchIdForUpdateInspectorVC]); 

  const convertEpochToTime = (epochTime) => {
    const date = new Date(epochTime * 1000); 
    return date.toLocaleString(); 
  };

  return (
    <div className="container mx-auto p-8 mb-10 pt-16">
      <div className="flex justify-between">
        {/* Update InspectorVC Form */}
        <div className="w-1/2 pr-4 mb-8">
          <h3 className="text-2xl font-semibold mb-4">Update Inspector Verifiable Credential</h3>
        <div className="flex items-center mb-4">
          <label className="mr-4">Batch ID:</label>
          <input
            type="text"
            value={batchIdForUpdateInspectorVC}
            onChange={(e) => setBatchIdForUpdateInspectorVC(e.target.value)}
            className="border p-2"
          />
        </div>
        <div className="flex items-center mb-4">
          <label className="mr-4">Inspector Check:</label>
          <select
            value={inspectorCheck}
            onChange={(e) => setInspectorCheck(e.target.value)}
            className="border p-2"
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
        <div className="flex items-center mb-4">
          <label className="mr-4">Danger Check:</label>
          <select
            value={dangerCheck}
            onChange={(e) => setDangerCheck(e.target.value)}
            className="border p-2"
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
        <div className="flex items-center mb-4">
          <label className="mr-4">Remark:</label>
          <input
            type="checkbox"
            checked={remarkEnabledInspectorVC}
            onChange={() => setRemarkEnabledInspectorVC(!remarkEnabledInspectorVC)}
            className="mr-2 h-6 w-6"
          />
          {remarkEnabledInspectorVC && (
            <input
              type="text"
              value={remarkInspectorVC}
              onChange={(e) => setRemarkInspectorVC(e.target.value)}
              className="border p-2 w-64"
            />
          )}
        </div>
        <button onClick={handleUpdateInspectorVC} className="bg-blue-500 text-white px-4 py-2 rounded">
          Update InspectorVC
        </button>
      </div>

        {/* Farm Data Display */}
        {farmData && (
          <div className="w-1/2 pl-14">
            <div className="border p-2 rounded-md">
            <h5 className="text-lg font-semibold mb-2">Meat Processor VC Data | BatchID {batchIdForUpdateInspectorVC}</h5>
              <div className="flex justify-between">
                <div className="text-left">
                  <p>Quantity:</p>
                  <p>Grading Results:</p>
                  <p>Country Of Origin:</p>
                  <p>Date of Production:</p>
                  <p>Expiry Date:</p>
                </div>
                <div className="text-right">
                  <p>{farmData.quantity}</p>
                  <p>{farmData.gradingResults}</p>
                  <p>{farmData.countryOfOrigin}</p>
                  <p>{convertEpochToDateTime(farmData.dateOfProduction)}</p>
                  <p>{convertEpochToDateTime(farmData.expiryDate)}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

    {/* Update Health Status Form */}
    <div className="mb-8">
    <h3 className="text-2xl font-semibold text-red-500 mb-4">Update Danger Status</h3>      <div className="flex items-center mb-4">
        <label className="mr-4">Batch ID:</label>
        <input
          type="text"
          value={batchIdForUpdateHealthStatus}
          onChange={(e) => setBatchIdForUpdateHealthStatus(e.target.value)}
          className="border p-2"
        />
      </div>
      <div className="flex items-center mb-4">
        <label className="mr-4">Approval:</label>
        <select
          value={approval}
          onChange={(e) => setApproval(e.target.value)}
          className="border p-2"
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>
      <div className="flex items-center mb-4">
        <label className="mr-4">Danger Check:</label>
        <select
          value={dangerCheckHealth}
          onChange={(e) => setDangerCheckHealth(e.target.value)}
          className="border p-2"
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>
      <div className="flex items-center mb-4">
        <label className="mr-4">Remark:</label>
        <input
          type="checkbox"
          checked={remarkEnabledHealthStatus}
          onChange={() => setRemarkEnabledHealthStatus(!remarkEnabledHealthStatus)}
          className="mr-2 h-6 w-6"
        />
        {remarkEnabledHealthStatus && (
          <input
            type="text"
            value={remarkHealthStatus}
            onChange={(e) => setRemarkHealthStatus(e.target.value)}
            className="border p-2 w-64"
          />
        )}
      </div>
      <button onClick={handleUpdateHealthStatus} className="bg-blue-500 text-white px-4 py-2 rounded">
        Update Danger Status
      </button>
    </div>

      {/* Search by BatchID Form */}        
      <h3 className="text-2xl font-semibold mb-4">Search InspectorVC</h3>
      <div className="mb-8 flex items-center"> 
    
        <div className="mr-4"> 
          <label className="mr-4">BatchID:</label>
          <input
            type="text"
            value={batchIdForSearch}
            onChange={(e) => setBatchIdForSearch(e.target.value)}
            className="border p-2"
          />
        </div>
        <button onClick={handleSearchByBatchIdInspector} className="bg-blue-500 text-white px-4 py-2 rounded">
          Search
        </button>
      </div>

      {/* Display searched InspectorVC data */}
      {searchedInspectorVC && (
        <div className="mb-8">
          <h3 className="text-2xl font-semibold mb-4">Search Result</h3>
          <p>BatchID: {searchedInspectorVC.batchID}</p>
          <p>Inspector Check: {searchedInspectorVC.inspectorCheck ? 'Yes' : 'No'}</p>
          <p>Danger Check: {searchedInspectorVC.dangerCheck ? 'Yes' : 'No'}</p>
          <p>Remark: {searchedInspectorVC.remark}</p>
          <p>Update Timestamp: {convertEpochToTime(searchedInspectorVC.timestamp)}</p>
        </div>
      )}

      {/* Display all InspectorVCs in a table */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-2xl font-semibold">Verifiable Credentials List</h3>

        <div>
          <label className="mr-4 text-lg">Search:</label>
          <input
            type="text"
            value={searchInputInspector}
            onChange={(e) => setSearchInputInspector(e.target.value)}
            className="border p-2"
          />
        </div>
      </div>

      <table className="w-full border">
        <thead>
          <tr className="bg-gray-200">
            <th className="border p-2 text-center" rowSpan="2">BatchID</th>
            <th className="border p-2 text-center" colSpan="5" style={{ backgroundColor: '#6EE7B7' }}>Meat Processor</th>
            <th className="border p-2 text-center" colSpan="4" style={{ backgroundColor: '#63B3ED' }}>Inspector</th>
          </tr>
          <tr className="bg-gray-200">
            <th className="border p-2 text-center bg-green-200">Quantity</th>
            <th className="border p-2 text-center bg-green-200">Grading Results</th>
            <th className="border p-2 text-center bg-green-200">Country Of Origin</th>
            <th className="border p-2 text-center bg-green-200">Date of Production</th>
            <th className="border p-2 text-center bg-green-200">Expiry Date</th>
            <th className="border p-2 text-center bg-blue-200">Inspector Check</th>
            <th className="border p-2 text-center bg-blue-200">Danger Check</th>
            <th className="border p-2 text-center bg-blue-200">Remark</th>
            <th className="border p-2 text-center bg-blue-200">Update Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {inspectorVCs
            .filter((inspectorVC) =>
              String(inspectorVC.batchID).toLowerCase().includes(searchInputInspector.toLowerCase()) ||
              String(inspectorVC.inspectorCheck).toLowerCase().includes(searchInputInspector.toLowerCase()) ||
              String(inspectorVC.dangerCheck).toLowerCase().includes(searchInputInspector.toLowerCase()) ||
              String(inspectorVC.remark).toLowerCase().includes(searchInputInspector.toLowerCase())
            )
            .filter((inspectorVC) => inspectorVC.batchID !== '0') // Exclude entries with BatchID 0
            .map((inspectorVC, index) => (
              <tr key={inspectorVC.batchID} className={inspectorVC.batchID % 2 === 0 ? 'bg-gray-100' : ''}>
                <td className="border p-2 text-center">{inspectorVC.batchID}</td>
                <td className={`border p-2 text-center bg-green-200`}>{farmerVCDetails[index] ? farmerVCDetails[index].quantity : '-'}</td>
                <td className={`border p-2 text-center bg-green-200`}>{farmerVCDetails[index] ? farmerVCDetails[index].gradingResults : '-'}</td>
                <td className={`border p-2 text-center bg-green-200`}>{farmerVCDetails[index] ? farmerVCDetails[index].countryOfOrigin : '-'}</td>
                <td className={`border p-2 text-center bg-green-200`}>{farmerVCDetails[index] ? convertEpochToDateTime(farmerVCDetails[index].dateOfProduction) : '-'}</td>
                <td className={`border p-2 text-center bg-green-200`}>{farmerVCDetails[index] ? convertEpochToDateTime(farmerVCDetails[index].expiryDate) : '-'}</td>
                <td className={`border p-2 text-center bg-blue-200 ${inspectorVC.inspectorCheck === false ? 'bg-red-200' : ''}`}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {inspectorVC.inspectorCheck ? (
                      <img src={tickImage} alt="tick" style={{ width: '20px', height: '20px' }} />
                    ) : (
                      <img src={crossImage} alt="cross" style={{ width: '20px', height: '20px' }} />
                    )}
                  </div>
                </td>
                <td className={`border p-2 text-center bg-blue-200 ${inspectorVC.dangerCheck === false ? 'bg-red-200' : ''}`}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {inspectorVC.dangerCheck ? (
                      <img src={tickImage} alt="tick" style={{ width: '20px', height: '20px' }} />
                    ) : (
                      <img src={crossImage} alt="cross" style={{ width: '20px', height: '20px' }} />
                    )}
                  </div>
                </td>
                <td className={`border p-2 text-center bg-blue-200`}>{inspectorVC.remark}</td>
                <td className={`border p-2 text-center bg-blue-200`}>{convertEpochToTime(inspectorVC.timestamp)}</td>
              </tr>
            ))}
        </tbody>
      </table>

    </div>
  );
};

export default InspectorPage;